import { resolveStorageUrl } from "../../utils/adminApiHelpers";
import { firstDefined, isPlainObject } from "../../utils/objectHelpers";

function resolveNewsImage(item) {
  const full = item?.image_url;
  if (full != null && typeof full === "string" && full.trim()) {
    return full.trim();
  }
  return resolveStorageUrl(item?.image ? String(item.image) : "");
}

/**
 * Map API shapes: nested title/content { ar, en }, flat keys, Laravel attributes.
 */
export function normalizeNewsItem(raw) {
  if (!raw || typeof raw !== "object") return null;
  const item = isPlainObject(raw.attributes) ? raw.attributes : raw;
  const id = item.id ?? raw.id;
  if (id == null) return null;

  const str = (v) => (v == null ? "" : String(v));

  const titleObj = isPlainObject(item.title) ? item.title : null;
  const contentObj = isPlainObject(item.content) ? item.content : null;

  return {
    id,
    title_ar: str(
      titleObj?.ar ??
        firstDefined(item, ["title_ar", "titleAr", "ar_title", "title_arabic"])
    ),
    title_en: str(
      titleObj?.en ??
        ((typeof item.title === "string" ? item.title : "") ||
          firstDefined(item, [
            "title_en",
            "titleEn",
            "en_title",
            "title_english",
          ]))
    ),
    content_ar: str(
      contentObj?.ar ??
        firstDefined(item, [
          "content_ar",
          "contentAr",
          "body_ar",
          "description_ar",
          "text_ar",
        ])
    ),
    content_en: str(
      contentObj?.en ??
        ((typeof item.content === "string" ? item.content : "") ||
          firstDefined(item, [
            "content_en",
            "contentEn",
            "body_en",
            "description_en",
            "text_en",
            "description",
          ]))
    ),
    image_url: resolveNewsImage(item),
  };
}
